import { building } from '$app/environment'

export const isInMsTeamsTab = (url?: URL) =>
  !building &&
  (url?.pathname.startsWith('/ms-teams-tab') ||
    url?.searchParams.has('ms-teams-tab') ||
    (typeof window !== 'undefined' &&
      (window != window.top ||
        new URLSearchParams(window.location.search).has('ms-teams-tab'))))
